<template>
    <div class="new-article-details">
        <div class="new-article-details-box" v-html="detail.content"></div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';
import { exhibitDetail } from '@/api/index';
const route = useRoute();
let type = ref('');
const detail = ref({});
const getDetail = () => {
    exhibitDetail({
        id: type.value
    }).then(({ data }) => {
        console.log(data, 333);
        detail.value = data;
    });
};
onMounted(() => {
    type.value = route.query.type;
    getDetail();
});
// const typeList = ref([
//     {
//         title: '大圣文化主题展',
//         subTitle: '东侧二层固定展厅',
//         content: '闽台自古就有“山尊大圣、海祭妈祖”的传统民俗。大圣文化是古闽越及早期汉民族自然崇拜的历史遗存，是中华优秀传统文化和闽人智慧的代表性内容。在融合中国释道文化的过程中，逐渐形成了独具特色的文化内涵。在顺昌，大圣文化可追溯至唐末五代，鼎盛于元明，至今已有千年历史。县域遍布宋元明清各时期大圣文化遗迹，目前，已发现祭坛、神位碑刻及庙堂120余处其中，以“通天大圣”冠名登记在册的祭坛及祭坛遗址78处。展览精选30处冠名“通天大圣”代表性坛庙。作为大圣祖地实物佐证，通过照片及简介形式进行展示，旨在传承和发扬大圣祖地文化时代精神内涵，绘就两岸大圣文化学术交流与民问往来新画卷',
//         img1: '/img-text/type1/img1.png',
//         img2: '/img-text/type1/img2.png'
//     },
//     {
//         title: '顺昌历史文化陈列展',
//         subTitle: '东侧二层固定展厅',
//         content: '展厅通过大圣文化的溯源、传承、交流、弘扬四个部分，诉说大圣文化的古往今来，带领观众朋友穿越时空，探索大圣文化的传承与发展，以及与现实相适应的时代精神，顺昌大圣文化发展至今，已成为新时代中华优秀传统文化创造性转化和创新性发展的生动案例。',
//         img1: '/img-text/type2/img1.png',
//         img2: '/img-text/type2/img2.png'
//     },
//     {
//         title: '合掌岩捐赠书画作品展',
//         subTitle: '东侧二层固定展厅',
//         content: '展览包含顺昌著名乡贤、中国书法家协会副主席叶培贵，国家一级美术师及丽霞、李瑞峰、张仕森、徐岩、曾文田等诸多国内书画名家作品。展览作品题材丰富、风格多样，涵盖了山水、花鸟、人物等画作以及行、楷等书法作品，具有较高的艺术价值。',
//         img1: '/img-text/type3/img1.png',
//         img2: '/img-text/type3/img2.png'
//     },
//     {
//         title: '邂逅闽地风华——跟着诗词游福建',
//         subTitle: '东侧二层固定展厅',
//         content: '“跟着诗词游福建”展览分为九个部分，各部分均以诗词为开篇，结合文物标本，介绍了省内独具特色的历史底蕴和人文气象。具体内容涵盖福州的西湖、三坊七巷、鼓山、罗星塔；厦门的鼓浪屿、金榜山；莆田的湄洲岛、木兰溪；泉州的洛阳桥、九日山、德化窑；漳州的东山岛、月港；龙岩的上杭、土楼；三明的万寿岩、宁化；南平的武夷山、北苑御茶园；宁德的霞浦、木拱廊桥等等。每一处风景都在诗词中被赋予了独特的灵魂。',
//         img1: '/img-text/type4/img1.png',
//         img2: '/img-text/type4/img2.png'
//     }
// ]);
</script>
<style scoped lang="scss">
.new-article-details {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #fff;
    .new-article-details-box {
        width: 1200px;
        padding-bottom: 134px;
        min-height: 550px;
        .new-article-details-box-title, h2{
            font-weight:700;
            color:#262626;
            font-size:29px;
            margin-top: 53px;
            text-align: center;
        }
        h2{
            text-align: left;
            font-size:20px;
            font-weight:normal;
            margin-bottom: 15px;
            margin-top: 15px;
        }
        .new-article-details-box-sub-title{
            font-weight:700;
            color:#262626;
            font-size:14px;
            margin-top: 9px;
            margin-bottom: 33px;
            text-align: center;
        }
        .new-article-details-box-content, p{
            font-weight:normal;
            color:#262626;
            font-size:14px;
            text-indent: 2em;
            margin-bottom: 15px;
        }

        img{
            width: 100%;
        }
    }
}
</style>